import api from "../../../helpers/api";

export const fetchProjects = async (params) => {
  const response = await api.get("/projects", { params });
  return response.data;
};
